<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Información SSO</span></li>
        <li><span class="link-effect">Seguimiento</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Seguimiento Información SSO</h3>
    </div>


    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.sedes" multiple>
                <mat-option *ngFor="let sede of listaSedes; index as i;"
                  [value]='sede.idSede'>{{sede.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Año:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.anio">
                <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Mes:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.meses" multiple>
                <mat-option *ngFor="let mes of meses; index as i;" [value]='mes.value'>{{mes.viewValue}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.idEstado">
                <mat-option *ngFor="let estado of listaEstados; index as i;"
                  [value]='estado.idParametroDetalle'>{{estado.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" (click)="search()" mat-raised-button><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
        <div class="form-group">
          <!-- <div class="col-sm-3 text-left"><label class="control-label">Avance de Información Completada:</label></div>
          <div class="col-sm-3 text-left"><mat-progress-bar [value]="30" [bufferValue]="30"></mat-progress-bar>  </div>
          <div class="col-sm-4 text-left"><label class="control-label">{{30}} % (12 de 30)</label></div> -->
          <div class="col-sm-12 text-right"><label class="control-label">Mes a declarar: {{currentCalendar.nombreMes}} -
              {{currentCalendar.anio}}</label></div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="listaFichas" multiTemplateDataRows class="table table-striped table-vcenter">
          <ng-container matColumnDef="anio">
            <th mat-header-cell *matHeaderCellDef>Año</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.anio}}</td>
          </ng-container>
          <ng-container matColumnDef="mes">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.nombreMes}}</td>
          </ng-container>
          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania}}</td>
          </ng-container>
          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.sede}}</td>
          </ng-container>
          <ng-container matColumnDef="ultimaModificacion">
            <th mat-header-cell *matHeaderCellDef>Ultima modificación</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.ultimaModificacion}}</td>
          </ng-container>

          <ng-container matColumnDef="fechalimite">
            <th mat-header-cell *matHeaderCellDef>Fecha Limite</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaLimite | date:'dd/MM/yyyy'}}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado}}</td>
          </ng-container>
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="centre">
              <!-- <a mat-icon-button color="primary" aria-label="Registrar" *ngIf="element.estado == 'Pendiente' && element.contratista =='ENGIE'"><mat-icon>create</mat-icon></a>
                  <a mat-icon-button color="primary" aria-label="Ver" *ngIf="(element.estado == 'Completado' || element.estado == 'Completado Fuera Plazo') && element.empresa !='ENGIE'"><mat-icon>search</mat-icon></a> -->
              <!-- <a mat-icon-button color="primary" (clic)="openDialogAmpliacion()" aria-label="Solicitar ampliación" *ngIf="element.estado == 'Pendiente'"><mat-icon>timer</mat-icon></a> -->
              <button mat-icon-button color="primary" aria-label="Solicitar ampliación de fecha"
                title="Solicitar ampliación de fecha" (click)="openDialogAmpliacion(element); $event.stopPropagation()"
                *ngIf="element.puedeAmpliar">
                <mat-icon>timer</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button aria-label="expand row"
                (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
              </button>
            </td>
          </ng-container>
          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
              <div class="example-element-detail"
                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm, element)" appIdentityRevealed>
                  <div class="content-detailTable">
                    <div class="form-horizontal">

                      <mat-accordion class="ficha-sso" multi>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              GENERAL
                            </mat-panel-title>
                          </mat-expansion-panel-header>

                          <div class="form-group">
                            <label class="col-md-1 control-label">Cantidad Personal:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadPersonal"
                                  [disabled]="!element.editable" name="cantidadPersonal" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" (click)="tooltip.show()" #tooltip="matTooltip"
                                matTooltip="Cantidad de personal" matTooltipPosition="above">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Cantidad Horas:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadHoras"
                                  [disabled]="!element.editable" name="cantidadHoras" maxlength="8" required
                                  appTwoDigitDecimaNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Horas Hombre trabajadas">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              ACCIDENTES
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">Leves:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.accidentesLeves"
                                  [disabled]="!element.editable" name="accidentesLeves" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Necesitó tratamiento médico sin generar descanso médico">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Incapacitantes:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.accidentesIncapacitantes"
                                  [disabled]="!element.editable" name="accidentesIncapacitantes" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Fue necesario otorgarle descanso médico al usuario">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Fatal:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.accidentesFatales"
                                  [disabled]="!element.editable" name="accidentesFatales" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Suceso cuyas lesiones produjeron la muerte del trabajador">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Días Perdidos:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.diasPerdidos"
                                  [disabled]="!element.editable" name="diasPerdidos" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Días perdidos a causa del accidente incapacitante : no se contabiliza el día que fue atendido en emergencias">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              INCIDENTES / ATENCIONES MÉDICAS
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">1° Auxilios:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.primerosAuxilios"
                                  [disabled]="!element.editable" name="primerosAuxilios" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="A causa de accidente leve y/o enfermedad ocupacional (no hubieron días perdidos, se necesito ambulancia o tópico)">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Inc. c/Daño M:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.incidentesConDanio"
                                  [disabled]="!element.editable" name="incidentesConDanio" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="La persona afectada no sufre lesiones corporales, pero sí daños materiales">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Inc. s/Daño M:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.incidentesSinDanio"
                                  [disabled]="!element.editable" name="incidentesSinDanio" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="La persona afectada no sufre lesiones corporales,ni daños materiales">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Inc. c/Potencial:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.incidentesConPotencial"
                                  [disabled]="!element.editable" name="incidentesConPotencial" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Suceso riesgoso que pudo causar lesiones o enfermedades">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Inc. Peligroso:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.incidentesPeligrosos"
                                  [disabled]="!element.editable" name="incidentesPeligrosos" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Suceso Peligroso">help</mat-icon>
                            </div><label class="col-md-1 control-label">Atenciones Médicas:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.atencionesMedicas"
                                  [disabled]="!element.editable" name="atencionesMedicas" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Personal que necesitó del uso de tópico o ambulancia por enfermedades comunes">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              ACTOS O CONDICIONES INSEGURA
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">Acto Inseguro:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.actosInseguros"
                                  [disabled]="!element.editable" name="actosInseguros" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Toda acción o práctica incorrecta ejecutada por el trabajador que puede causar un accidente">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Condición Insegura:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.condicionesInseguras"
                                  [disabled]="!element.editable" name="condicionesInseguras" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Toda condición en el entorno del trabajo que puede causar un accidente">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              CHARLAS DE SEGURIDAD / HORAS CAPACITACIÓN & TRAINING
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">Charla Semanal:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.charlasSemanales"
                                  [disabled]="!element.editable" name="charlasSemanales" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Charlas Semanales">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Charla de 5 min.:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.charlas5Minutos"
                                  [disabled]="!element.editable" name="charlas5Minutos" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Charlas de 5 minutos">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">HH Capacitación:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.horasCapacitacion"
                                  [disabled]="!element.editable" name="horasCapacitacion" maxlength="8" required
                                  appTwoDigitDecimaNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Horas consideradas como parte teórica del curso o capacitación.">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">HH Training:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.horasEntrenamiento"
                                  [disabled]="!element.editable" name="horasEntrenamiento" maxlength="8" required
                                  appTwoDigitDecimaNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Horas consideradas como parte práctica del curso o capacitación">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              PT, ATS, OTROS
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">PT:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadPT"
                                  [disabled]="!element.editable" name="cantidadPT" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Cantidad de Permisos de trabajo (PT) emitidos mensualmente">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">ATS:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadATS"
                                  [disabled]="!element.editable" name="cantidadATS" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Cantidad de Análisis de Trabajo Seguro (ATS) emitidos mensualmente">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">PTAR:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadPTAR"
                                  [disabled]="!element.editable" name="cantidadPTAR" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Cantidad de Permisos de Trabajo de Alto Riesgo (PTAR) emitidos mensualmente">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Auditorías:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadAuditorias"
                                  [disabled]="!element.editable" name="cantidadAuditorias" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Cantidad de auditorías realizadas en el mes">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Simulacro:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadSimulacros"
                                  [disabled]="!element.editable" name="cantidadSimulacros" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip"
                                matTooltip="Número deSimulacros de emergencia realizados en el mes">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              OBJETIVOS SSO - OPERACIONES
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label"># Caminatas:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline">
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadCaminatas"
                                  [disabled]="!element.editable" name="cantidadCaminatas" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Cantidad de Caminatas">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label"># Safety Moments:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline">
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="text" [(ngModel)]="element.cantidadSafetyMoments"
                                  [disabled]="!element.editable" name="cantidadSafetyMoments" maxlength="4" required
                                  appOnlyNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="Cantidad de Safety Moments">help</mat-icon>
                            </div>
                            <label class="col-md-1 control-label">Avance PASST:</label>
                            <div class="col-md-1">
                              <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>%</mat-label>
                                <input matInput type="text" [(ngModel)]="element.avancePasst"
                                  [disabled]="!element.editable" name="avancePasst" maxlength="5" required
                                  appTwoDigitDecimaNumber />
                              </mat-form-field>
                              <mat-icon class="icon-tooltip" matTooltip="% de avance de PASST">help</mat-icon>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true" disabled>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              ADJUNTO
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="form-group">
                            <label class="col-md-1 control-label">Archivo (*):</label>
                            <label class="col-md-4 control-label label-link">
                              <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                              <!-- <mat-form-field appearance="outline">
                          <mat-label>
                            Seleccione Archivo
                          </mat-label>
                          <input matInput type="text" placeholder="Seleccione Archivo" maxlength="40"
                            name="nombreArchivo" [(ngModel)]="element.nombreArchivo" disabled>
                            
                        </mat-form-field>    -->

                            </label>
                            <div class="col-md-1">
                              <input type="file" class="file-input"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" #fileUpload
                                (change)="uploadFile(fileUpload.files, element)" style="display: none;" />
                              <button type="button" mat-icon-button color="primary" aria-label="adjuntar"
                                matTooltip="Adjuntar documento" (click)="fileUpload.click()">
                                <mat-icon>folder</mat-icon>
                              </button>
                            </div>
                          </div>
                        </mat-expansion-panel>
                      </mat-accordion>
                      <div class="form-group ficha-sso">
                        <div class="col-sm-12 text-right">
                          <!-- <button type="submit" class="btn btn-naranja" mat-raised-button >Guardar</button> -->
                          <button type="submit" *ngIf="element.editable" class="btn btn-naranja" mat-raised-button
                            (click)="saveFicha(element)" aria-label="Editar">
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
          <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

        </table>

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>